<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $tc('messages.gamification_sets', 2),
                        href: meta.links.set_index,
                    },
                    {
                        name: gamificationSet.breadcrumb_title,
                        href: meta.links.set_show,
                    },
                    {
                        name: $tc('messages.card_collections', 2),
                        href: meta.links.index,
                    },
                    {
                        name: card_collection.name,
                        href: null,
                    },
                ]"
            />
        </template>

        <div>
            <NavLinks :links="meta.navGroupLinks" />
        </div>

        <div>
            <div class="md:col-span-2">
                <label for="all" class="block text-sm font-medium leading-5 text-gray-700">
                    {{ $t('messages.all') }}
                </label>
                <div class="mt-1">
                    <input
                        type="checkbox"
                        id="all"
                        name="all"
                        v-model="all"
                        class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                    />
                </div>
            </div>
        </div>

        <div class="m-3">
            <div class="md:grid md:grid-cols-3 lg:grid-cols-6 md:gap-6">
                <div
                    class="flex shrink-0 space-x-2 bg-white rounded-xl p-2"
                    v-for="student in filteredStudents"
                    :key="student.id"
                >
                    <img
                        :src="student.avatar_or_profile_photo"
                        alt=""
                        class="max-w-none h-16 w-16 rounded-full ring-2 ring-white"
                    />
                    <div class="flex flex-col">
                        <div :title="student.full_name">
                            {{ student.first_name_and_initial }}
                        </div>
                        <div v-if="student.collection_level">
                            <BadgePill>
                                {{ student.collection_level }}
                            </BadgePill>
                        </div>
                        <div>
                            {{ student.cards_count }} /
                            {{ card_collection.cards_count }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';

import '@uppy/core/dist/style.css';
import '@uppy/dashboard/dist/style.css';
import BadgePill from '@/components/BadgePill.vue';
import NavLinks from '@/components/NavLinks.vue';

export default {
    components: {
        PanelPage,
        BadgePill,
        NavLinks,
    },
    layout: Layout,
    name: 'Edit',
    props: ['teacher', 'meta', 'options', 'card_collection', 'gamificationSet'],
    data() {
        return {
            all: true,
        };
    },
    computed: {
        filteredStudents: function () {
            let students = this.card_collection.students;
            if (!this.all) {
                students = students.filter((s) => !!s.collection_level);
            }
            return students;
        },
    },
};
</script>
